import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';
import validateUUID from "uuid-validate";
import { useProducts } from '../../../providers/ProductProvider';
import { useAuth } from '../../../providers/AuthenticationProvider';
import { NumericFormat } from 'react-number-format';
const WEB_PAGE = 'Products';

const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    border: 'solid #707070',
    borderRadius: '10px',
    borderWidth: 'thin',
    backgroundColor: 'white',
    width: '30%',
    alignItems: 'center',
    padding: '2% 0% 2% 0%'
};

const fontStyles = {
    display: 'flex',
    fontSize: '20px',
    color: '#153A4B',
};

const priceBoxStyle = {
    borderRadius: '7px',
    border: 'solid',
    outline: 'none',
    borderColor: '#00A7B5',
    boxShadow: '.5px .5px 2px #00A7B5',
    marginTop: '5px',
    marginBottom: '20px',
    color: '#153A4B',
    display: 'flex',
    height: '25px',
    borderWidth: 'thin',
    padding: '5px',
    width: '97%',
    fontSize: '20px',
};

const toastSection = {
    marginTop: '1%'
};

export const EditProduct = () => {
    const { checkAuth, getUserType } = useAuth();
    const { id } = useParams();
    const [name, setName] = useState('');
    const [componentId, setComponentId] = useState("");
    const [price, setPrice] = useState(null);
    const [description, setDescription] = useState('');
    const [type, setType] = useState();
    const [occurrence, setOccurrence] = useState();
    const [units, setUnits] = useState();
    const [enabled, setEnabled] = useState();
    const [productDistributorId, setProductDistributorId] = useState();
    const [loading, setLoading] = useState(true);
    const [allowedToEdit, setAllowedToEdit] = useState(false);
    const { fetchProduct, editProduct, deleteProduct, toggleProduct, productTypes, productOccurrences, productUnits } = useProducts();
    const { distributor, isSystemAdmin } = useAuth();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    useEffect(() => {
        fetchProduct(id).then(data => {
            setLoading(false);
            setName(data.name);
            setPrice(data.price);
            setDescription(data.description ?? '');
            setType(data.type ?? '');
            setOccurrence(data.occurrence ?? '');
            setUnits(data.units ?? '');
            setProductDistributorId(data.distributorId);
            setComponentId(data.componentId ?? '');
            setEnabled(data.enabled);
        });
    }, [id, fetchProduct]);

    useEffect(() => {
        if (productDistributorId === distributor?.id || (productDistributorId === null && distributor === null)) {
            setAllowedToEdit(true);
        } else {
            setAllowedToEdit(false);
        }
    }, [productDistributorId, distributor])

    const handleSubmit = async e => {
        e.preventDefault();
        if (componentId === "" || validateUUID(componentId)) {
            await editProduct(id, name, price, description, type, occurrence, units, componentId);
            navigate('/products');
        }
        else {
            toast({
                type: 'error',
                description: 'Component ID should be a valid UUID',
                animation: 'fade down',
                time: 5000
            });
        }
    };

    const handleDelete = async e => {
        await deleteProduct(id);
        navigate('/products');
    };

    const handleToggle = async e => {
        try {
            await toggleProduct(distributor.id, id, !enabled);
            toast({
                type: 'success',
                description: 'Item has been ' + ((enabled) ? 'enabled' : 'disabled'),
                animation: 'fade down',
                time: 5000
            });
        } catch (err) {
            toast({
                type: 'error',
                description: 'Sorry the item could not be ' + ((enabled) ? 'enabled' : 'disabled'),
                animation: 'fade down',
                time: 5000
            });
        }
        fetchProduct(id).then(data => { setEnabled(data.enabled); });
    };



    return (
        <div>
            <div style={{ fontSize: '35px', color: '#153A4B' }}>
                <p style={{ margin: '15px 15px 15px 0px' }}>Edit a Product</p>
            </div>
            <form onSubmit={handleSubmit}>
                <Segment className="createGreyBox" style={containerStyle}>
                    <Dimmer active={loading} inverted>
                        <Loader active={loading} size="massive" inline />
                    </Dimmer>
                    <div className="productDetails" style={{ width: '80%' }}>
                        <div className="productName">
                            <label style={fontStyles}>Product Name</label>
                            <input
                                type="text"
                                name="ProductName"
                                id="ProductName"
                                placeholder="Product Name"
                                maxLength="50"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                disabled={!allowedToEdit}
                                required
                            />
                        </div>
                        { 
                            isSystemAdmin &&
                            <div className="componentId">
                                <label style={fontStyles}>Component Id</label>
                                <input
                                    type="text"
                                    name="ComponentId"
                                    id="ComponentId"
                                    placeholder="Component Id"
                                    value={componentId}
                                    onChange={e => setComponentId(e.target.value)}
                                />
                            </div>
                        }
                        <div className="productType">
                            <label style={fontStyles}>Type</label>
                            <select
                                name="ProductType"
                                id="ProductType"
                                value={type}
                                onChange={e => setType(e.target.value)}
                                disabled={!allowedToEdit}
                                required
                                defaultValue={""}
                            >
                                <option value="" disabled hidden>Select Type</option>
                                {productTypes.map((productType) => {
                                    return (
                                        <option key={productType} value={productType}>{productType}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="productOccurrence">
                            <label style={fontStyles}>Occurrence</label>
                            <select
                                name="ProductOccurrence"
                                id="ProductOccurrence"
                                value={occurrence}
                                onChange={e => setOccurrence(e.target.value)}
                                disabled={!allowedToEdit}
                                required
                                defaultValue={""}
                            >
                                <option value="" disabled hidden>Select Occurrence</option>
                                {productOccurrences.map((productOccurrence) => {
                                    return (
                                        <option key={productOccurrence} value={productOccurrence}>{productOccurrence}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div>
                            <label htmlFor="currency-field" style={fontStyles}>
                                Price
                            </label>
                            <NumericFormat
                                value={price}
                                displayType={'input'}
                                thousandSeparator={true}
                                prefix={'$'}
                                onValueChange={values => setPrice(values.value)}
                                style={priceBoxStyle}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                disabled={!allowedToEdit}
                                required
                            />
                        </div>
                        <div className="productUnit">
                            <label style={fontStyles}>Unit</label>
                            <select
                                name="ProductUnit"
                                id="ProductUnit"
                                value={units}
                                onChange={e => setUnits(e.target.value)}
                                required
                                disabled={!allowedToEdit}
                                defaultValue={""}
                            >
                                <option value="" disabled hidden>Select Unit</option>
                                {productUnits.map((productUnit) => {
                                    return (
                                        <option key={productUnit} value={productUnit}>{productUnit}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div>
                            <label style={fontStyles}>Description</label>
                            <textarea
                                id="description"
                                name="Description"
                                rows="4"
                                cols="50"
                                placeholder="Product description..."
                                maxLength="500"
                                style={{
                                    fontFamily: 'FranklinGothic-Light',
                                    color: '#153A4B',
                                    fontSize: '20px',
                                }}
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                                disabled={!allowedToEdit}
                            />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            {
                                allowedToEdit ? (
                                    <>
                                        <button name="Save" className="Save" value="Save">
                                            Save
                                        </button>
                                        <div className="buttons" style={{ justifyContent: 'flex-end' }}>
                                            <Link to="/products">
                                                <button type="button" name="Cancel" className="Cancel" value="Cancel">
                                                    Cancel
                                                </button>
                                            </Link>
                                        </div>
                                        <div className="buttons" style={{ justifyContent: 'flex-start' }}>
                                            <button type="button" name="delete" className="Delete" onClick={handleDelete}>
                                                Delete
                                            </button>
                                        </div>
                                    </>
                                ) : null
                            }
                            {
                                !allowedToEdit ? (
                                    <>
                                        <div className="buttons" style={{ justifyContent: 'flex-end' }}>
                                            <Link to="/products">
                                                <button type="button" name="Cancel" className="Cancel" value="Cancel">
                                                    Cancel
                                                </button>
                                            </Link>
                                        </div>

                                        <button type="button" name="toggle" className={"Cancel"}
                                            style={{ color:'white', backgroundColor: enabled ? '#d01919' : '#16ab39' }}
                                            onClick={handleToggle}>
                                            {enabled ? 'Disable' : 'Enable'}
                                        </button>
                                    </>
                                ) : null
                            }
                        </div>
                    </div>
                    <div style={toastSection}>
                        <SemanticToastContainer position="bottom-center" />
                    </div>
                </Segment>
            </form>
        </div>
    );
};
